/** @module MaterialSpec/DeleteMaterialPlanPlacement */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/config",
	"csi/table/Delete",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,lang,_,action,Controller,PostRequest,config,Delete,MessageDialog,xml) {

	return declare(Delete, {
		LOCK_THEME_PLACEMENT_LIST: "LockThemePlacementList",

		/**
		 * Customize confirmation dialog C8-9612
		 * @param {Object} params - parameters for action
		 */
		confirmAction: function(params) {
			var themeNode = this.getParent();
			var bomType = themeNode.ThemeBOMType;
			var lockThemePlacementList = false;
			if (xml.isValidURL(bomType)) {
				lockThemePlacementList = config.getSubtypeSetting(bomType, this.LOCK_THEME_PLACEMENT_LIST);
			}
			if (lockThemePlacementList) {
				params.buttons = [MessageDialog.BUTTON_DELETE, MessageDialog.BUTTON_CANCEL];
			} else {
				params.buttons = [MessageDialog.BUTTON_DELETE, "SelectStyleBOMs", MessageDialog.BUTTON_CANCEL];
			}
			var materialName = "";
			if (xml.isValidURL(this.getNode().Actual))
				materialName = this.getCache().getNode(this.getNode().Actual).$Name;
			params.message = this.getString(action.SUFFIX_CONFIRM, [this.getNode().$Name, materialName, themeNode.$Name]);
			this.inherited(arguments);
		},

		/**
		 * Cancel, go to delete request directly or open Style BOM view
		 * @param {String} key - which button pressed
		 */
		onConfirm: function(key) {
			if (key == MessageDialog.BUTTON_CANCEL) {
				this.postProcess();
			} else if (key == MessageDialog.BUTTON_DELETE) {
				this.process();
			} else{
				// the delete action always has a confirmation dialog, thus its preProcess opens Confirmation Dialog
				// therefore calling preProcess of Action Controller to popup the view with Style BOMs
				Controller.prototype.preProcess.call(this);
			}
		},

		/**
		 * Issue request so as to be able to receive return value
		 */
		process: function() {
			var req = this.m_action.m_request;
			var fd = this.m_formData;
			this.setProgress();
			new PostRequest(req.m_module, req.m_operation)
				.addParameter("ParentURL", this.m_urlParent)
				.addParameter("URL", this.m_urlNode)
				.addParameter("AddURLs", fd ? fd.getSelectedValue() : null)
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
	});
});